module.exports = __webpack_public_path__ + "static/media/regalo_mine.e4c3541d.png";